/* eslint-disable no-unused-vars */
export type IFilingStatus = 'yes' | 'no' | 'cast' | 'invited' | 'archived' | 'unfiled';
export type ApplicationSort = { id: string; sortType: IFilingStatus };

export enum FilingStatusEnum {
    YES = 'yes',
    NO = 'no',
    INVITED = 'invited',
    ARCHIVED = 'archived',
    UNFILED = 'unfiled',
}
